import { render, staticRenderFns } from "./high-frequency-label.vue?vue&type=template&id=57a07c9e&scoped=true&"
import script from "./high-frequency-label.vue?vue&type=script&lang=js&"
export * from "./high-frequency-label.vue?vue&type=script&lang=js&"
import style0 from "./high-frequency-label.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./high-frequency-label.vue?vue&type=style&index=1&id=57a07c9e&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a07c9e",
  null
  
)

export default component.exports